import { Component, Input, OnInit } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { selectAllRentals } from '@tokeet-frontend/tv3-platform'
import { selectAvailableAutomationChannels } from '@tokeet-frontend/automations'
import { FormGroup } from '@angular/forms'

@Component({
  selector: 'app-automation-channel-rental-select',
  templateUrl: './automation-channel-rental-select.component.html',
  styleUrls: ['./automation-channel-rental-select.component.scss'],
})
export class AutomationChannelRentalSelectComponent implements OnInit {
  @Input() form: FormGroup

  @Input() allowsChannel = true
  @Input() allowsRental = true

  rentals$ = this.store.pipe(select(selectAllRentals))
  channels$ = this.store.pipe(select(selectAvailableAutomationChannels))

  constructor(private store: Store<any>) {}

  ngOnInit(): void {}
}
